let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("30KI2")).then(() => parcelRequire('194dz'));